"use client";
import { Box } from "@mui/material";

import { useStore, observer } from "../../../../service/mobx";
import Content from "../../Pane/Content";

function MainContentSwap({ article, model }) {
  const { device, reader } = useStore();

  if (device.isDesktop) {
    return reader.viewing === "paper" ? article : model;
  } else {
    const section = reader.relatedContentFiltered.filter(
      content => content[3] === reader.tab
    );

    return reader.tab === "paper" ? (
      <Box width="100%">{article}</Box>
    ) : reader.tab === "model" ? (
      model
    ) : (
      <Box px={1} pt={4} pb={8}>
        {section.map(([title, items, cardType, url]) => (
          <Content
            showAll
            url={url}
            tab={reader.tab}
            key={title}
            title={title}
            items={items}
            cardType={cardType}
          />
        ))}
      </Box>
    );
  }
}

export default observer(MainContentSwap);
